import { IReportState } from "./interfaces";
import { loadLocalChanges } from "./utils";

export const LS_NAME = "localChanges";
export const LOCAL_USER = -1;

export const DEFAULT_REPORT_STATE: IReportState = {
	data: loadLocalChanges(),
};
